import { withClassNames } from '~/styles'
import s from './help.module.scss'
import { motion } from 'framer-motion'
const cx = withClassNames(s)

export const QuestionAnimation = {
  init: {
    opacity: 0,
    x: -42,
  },
  leave: {
    opacity: 0,
    scale: 0,
  },
  enter: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.5, damping: 15.3, type: 'spring' },
  },
}

export const HelpPage = () => {
  return (
    <div className={cx('help-container', 'container')}>
      <motion.h1 className={cx('heading', 'rainbow-text')}>
        Your questions answered
      </motion.h1>
      <motion.div
        variants={{
          enter: {
            transition: {
              staggerChildren: 0.07,
            },
          },
        }}
        className={cx('faq-container')}
      >
        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>What are Digital Moments?</h2>
          <h4>
            Digtal Moments are NFT’s (Non-Fungible Tokens) and make it possible to verify ownership of
            digital assets through the blockchain.
          </h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>What is a “Moment”?</h2>
          <h4>
            A moment is a unique video clip that is licensed by the content
            owner.
          </h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>What is a “Serial Number”?</h2>
          <h4>
            Each moment will have its own unique serial number. For example, if
            a “Legendary" moment has 150 mints, each moment will have a unique
            serial number from 1 to 150 and can not be duplicated.
          </h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>How do I get a physical collectible?</h2>
          <h4>
            Physical collectibles will either be for presale, or will have to be
            pulled out of a digital pack. If a “Legendary" or "Legendary Refractor" is pulled
            out of a pack, you will have the ownership of the physical collectible and can 
            get it shipped to your door for free.
          </h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>What wallet stores my Digital Moments?</h2>
          <h4>All ABD moments will be stored in the “Blocto” wallet.</h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>Where can I view my Digital Moments?</h2>
          <h4>
            Your Digital Moments will be stored on our website through the Blocto
            wallet. Sign in, go to “My collection” and all your moments that you
            own will appear.
          </h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>What blockchain/crypto does ABD use?</h2>
          <h4>ABD uses the Flow Blockchain.</h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>
            What about the energy usage of cryptocurrency?
          </h2>
          <h4>
            The energy consumption of the Flow Blockchain is extremely
            efficient. Each time an NFT is minted, it takes up as much energy as
            a Instagram post or a Google search.
          </h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>Does ABD accept crypto?</h2>
          <h4>
            We currently only accept Credit Card for all transactions. In the
            future, we will consider opening up to other crypto currencies.
          </h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>What can I do with my Digital Momentes?</h2>
          <h4>
            In the near future, we will open up our marketplace to be able to
            buy, sell and trade your moments with other users. There will also be
            functionality built into our moments to provide access to unique and
            limited product drops, single-use discount codes to your favorite
            brands, early access to our upcoming drops, and much more.
          </h4>
        </motion.div>

        <motion.div variants={QuestionAnimation} className={cx('question')}>
          <h2 className='rainbow-text'>
            What is the difference between Standard and Premium packs?
          </h2>

          <h4>
            Premium packs will have significantly higher odds of pulling a
            “Legendary” Moment.
          </h4>
        </motion.div>
      </motion.div>
    </div>
  )
}
